<!-- Image -->
<img
  [src]="listing().primaryImage"
  [alt]="listing().address.streetAddress"
  width="336"
  height="144"
  class="w-full h-36 object-cover"
  placeholder
/>

<!-- Tags -->
@if (listing().openToday || listing().openTomorrow) {
  <div class="absolute top-0 left-0 flex gap-1 p-2 flex-wrap max-w-38">
    <app-home-listing-card-open-house
      [listing]="listing()"
      [openNow]="openNow()"
      class="flex gap-1 flex-wrap"
    />
  </div>
}

<div class="p-4 flex flex-col gap-0.5 text-sm leading-none my-auto">
  @if (!listing().pending) {
    <p class="font-header text-2xl leading-none text-primary-500 dark:text-white/70 mb-2">
      {{ listing().price | currency: 'USD' : 'symbol' : '1.0-0' }}
    </p>
  }

  <p class="dark:text-gray-100!">{{ listing().model?.title }}</p>

  <p>
    <strong>{{ listing().beds }}</strong> bd | <strong>{{ baths() }}</strong> ba |
    @if (listing().den || listing().customFilters?.den) {
      <strong>1</strong> den |
    }
    <strong>{{ $safeNavigationMigration(listing().squareFeet?.total) | number }}</strong> sqft
  </p>

  <!-- Address -->
  <p>{{ listing().address.streetAddress }}</p>

  @if (stateService.community() === 'villages') {
    <p>{{ listing().village.displayTitle }}</p>
  }
</div>
